import type { FC } from 'react';

import { Button } from '@wwe-portal/ui/components/button/button';
import { ClaimAllIconWithToolTip } from '@wwe-portal/ui/features/offer/offer-card/claim-all-icon';
import { cn } from '@wwe-portal/ui/lib/lib';

export const ClaimAllButton: FC<{
  onClaimAll?: () => void;
  isClaimAllAble?: boolean;
  tooltipContent: string;
  className?: string;
}> = ({ onClaimAll, isClaimAllAble, tooltipContent, className }) => {
  return (
    <div className="flex items-center justify-center">
      <div className="mr-[12px]">
        <ClaimAllIconWithToolTip tooltipContent={tooltipContent} />
      </div>
      <Button
        className={cn('px-5 text-white', className)}
        disabled={!isClaimAllAble}
        onClick={() => isClaimAllAble && onClaimAll?.()}
        variant="green"
      >
        <div className="flex flex-row items-center justify-center gap-2">
          <span className="font-poppins text-center text-xs font-[600]">
            Claim All
          </span>

          {Boolean(isClaimAllAble) && (
            <div className="h-[6px] w-[6px] rounded-[3px] bg-[#CE5C5C]" />
          )}
        </div>
      </Button>
    </div>
  );
};
